import React from "react";
import { AppShell } from "../../components/Sidebar";
import { useAuth } from "../../context/AuthContext";
import { User, Mail, Phone, School } from "lucide-react";

export default function StudentSettings() {
  const { user } = useAuth();
  if (!user) return null;
  const initials = user.full_name.split(" ").map((s) => s[0]).slice(0, 2).join("").toUpperCase();

  return (
    <AppShell role="student">
      <h1 className="text-3xl font-extrabold tracking-tight text-slate-900">Settings</h1>
      <p className="mt-1 text-slate-500">View your account information.</p>

      <div className="mt-7 rounded-2xl border border-slate-100 bg-white p-6 shadow-card">
        <div className="flex flex-col items-start gap-4 sm:flex-row sm:items-center">
          <div className="flex h-20 w-20 items-center justify-center rounded-full bg-indigo-100 text-3xl font-bold text-indigo-700">
            {initials}
          </div>
          <div className="flex-1">
            <h2 className="text-2xl font-bold text-slate-900">{user.full_name}</h2>
            <p className="text-sm text-slate-500">{user.class_label} • Roll No. {user.roll_no}</p>
            <p className="mt-1 text-sm text-slate-500"><School className="mr-1 inline" size={14} /> {user.school_name}</p>
          </div>
        </div>
      </div>

      <div className="mt-6 grid gap-4 rounded-2xl border border-slate-100 bg-white p-6 shadow-card sm:grid-cols-2">
        <FieldRow icon={User} label="Username" value={user.username} />
        <FieldRow icon={Mail} label="Email" value={user.email} />
        <FieldRow icon={Phone} label="Mobile" value={user.mobile} />
        <FieldRow icon={School} label="School" value={user.school_name} />
      </div>
    </AppShell>
  );
}

const FieldRow = ({ icon: Icon, label, value }) => (
  <div className="flex items-center gap-3 rounded-xl bg-slate-50 px-4 py-3">
    <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-white text-slate-500 shadow-sm"><Icon size={16} /></div>
    <div>
      <p className="text-xs text-slate-500">{label}</p>
      <p className="text-sm font-semibold text-slate-900">{value}</p>
    </div>
  </div>
);
